import { apiClient } from "./api-client";

export async function login(username: string, password: string) {
  const response: any = await apiClient.post('/auth/login', { username, password });

  return response.data;
}

export async function logout() {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("user");
}

export async function refreshToken(refreshToken: string) {
  const response = await apiClient.post('/auth/refresh', { refreshToken });
  return response.data;
}

export async function getProfile() {
  const response = await apiClient.get('/auth/profile');
  return response.data;
}

export async function validateToken() {
  const response = await apiClient.get('/auth/validate');
  return response.data;
}

export async function ping() {
  const response = await apiClient.post('/auth/ping');
  return response.data;
}